/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import { Button, Typography2 } from '@coursera/cds-core';

import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';

const styles = {
  description: css`
    margin-bottom: 12px;
    margin-top: 8px;
  `,
  container: (expanded: boolean) => css`
    position: relative;
    line-height: 1.5ex;
    height: ${expanded ? 'none' : '9.5ex'};
    overflow: hidden;
  `,
};

type Props = {
  text?: string;
};

export const ReadMoreToggle: React.FC<Props> = ({ text }) => {
  const theme = useDegreeDescriptionPageTheme();
  const [expanded, setExpanded] = useState(false);
  const [longContent, setLongContent] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const containerHeight = containerRef?.current?.clientHeight;
    const contentHeight = contentRef?.current?.clientHeight;

    if (contentHeight && containerHeight && contentHeight > containerHeight) {
      setLongContent(true);
    } else {
      setLongContent(false);
    }
  }, [text]);

  return (
    <React.Fragment>
      <div css={styles.container(expanded)} ref={containerRef}>
        <div ref={contentRef}>
          <Typography2 component="p" variant="bodyPrimary" css={[styles.description, theme.mobileFontSizeStyle?.body]}>
            {text}
          </Typography2>
        </div>
      </div>
      {longContent && (
        <div
          css={css`
            padding-bottom: 8px;
          `}
        >
          <Button
            variant="ghost"
            css={css`
              padding: 0;
            `}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            {expanded ? 'Show less' : 'Show more'}
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};
